import International from "../../images/icons/countries/International.svg";
import Ukraine from "../../images/icons/countries/Ukraine.svg";
import Germany from "../../images/icons/countries/Germany.svg";
import Kazakhstan from "../../images/icons/countries/Kazakhstan.svg";
import Moldova from "../../images/icons/countries/Moldova.svg";
import English from "../../images/icons/English.svg";

export const countriesArray = [
  {
    name: "International",
    image: International,
  },
  {
    name: "Ukraine",
    image: Ukraine,
  },
  {
    name: "Germany",
    image: Germany,
  },
  {
    name: "Kazakhstan",
    image: Kazakhstan,
  },
  {
    name: "Moldova",
    image: Moldova,
  },
];

export const languagesArray = [
    {
        name: "English",
        image: English,
    },
    {
        name: "Українська"
    }
]
